"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const styles_1 = __importDefault(require("./styles"));
const buttonColorMap = {
    primary: 'primary',
    primaryLight: 'primary',
    secondary: 'secondary',
    secondaryLight: 'secondary',
    default: 'default',
};
const Button = ({ id, children = null, color = 'default', disabled = false, variant = 'default', loading = false, onClick = () => { }, type = 'button', style, className, }) => {
    const classes = styles_1.default({ color, variant });
    const buttonColor = buttonColorMap[color];
    const muiButtonText = variant === 'text' ? 'text' : 'contained';
    return (react_1.default.createElement(core_1.Button, { id: id, className: [className, classes.button].join(' '), classes: { label: classes.label }, color: buttonColor, disableFocusRipple: true, disableRipple: true, disabled: loading || disabled, onClick: onClick, variant: muiButtonText, type: type, style: style }, loading ? react_1.default.createElement(core_1.CircularProgress, { size: 24 }) : children));
};
exports.default = Button;
